import InterestedParties from './InterestedPartiesContainer';

export default InterestedParties;
